import useSetColumns from "./useSetColumns";
import { columnsType } from "../../../../common/types/search/results";

export const ColumnsInitializer = ({ columns }: { columns: columnsType }) => {
	useSetColumns(columns);

	return null;
};
